export default {
  Money: 1,
  Debit: 2,
  Credit: 3,
  App: 4
}
